import { Helmet } from 'react-helmet';

export default function StructuredData() {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'FinancialService',
    name: 'Carter Asset Management',
    url: 'https://www.carteram.com',
    logo: 'https://www.carteram.com/favicon.svg',
    description:
      'Fiduciary financial planning, disciplined investment management, and proactive tax strategy for families, founders, and retirees.',
    telephone: '+1-512-555-0123',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '100 Congress Ave, Suite 1500',
      addressLocality: 'Austin',
      addressRegion: 'TX',
      postalCode: '78701',
      addressCountry: 'US'
    },
    sameAs: [
      'https://www.linkedin.com/company/carter-asset-management',
      'https://www.youtube.com/@carterassetmanagement'
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}
